import React, { useRef } from "react";
import emailjs from "emailjs-com";

const ConsultationForm = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    alert("Your Form Has Been Submitted Successfully.")
  };

  return (
    <div className="consultation-form-wrap" style={{width: "32rem"}}>
      <h4 className="title">Free Consultation</h4>
      <form ref={form} onSubmit={sendEmail}>
        <div className="form-grp">
          <input type="text" name="user_name" placeholder="Name" required />
        </div>
        <div className="form-grp">
          <input type="email" name="user_email" placeholder="Email Address" required />
        </div>
        <div className="form-grp">
          <input type="text" name="user_phone" placeholder="Phone Number" required />
        </div>
        <div className="form-grp">
          <select name="user_subject" className="form-select" required>
            <option value="">Subject</option>
            <option value={"Logo Design"}>Logo Design</option>
            <option value={"Web Designing"}>Web Designing</option>
            <option value={"Brand Design"}>Brand Design</option>
            <option value={"Packaging Design"}>Packaging Design</option>
            <option value={"UI/UX Design"}>UI/UX Design</option>
            <option value={"Business Advertising"}>Business Advertising</option>
            <option value={"SEO"}>SEO</option>
            <option value={"Brand Strategy"}>Brand Strategy</option>
            <option value={"PPC"}>PPC</option>
            <option value={"Content Writing"}>Content Writing</option>
            <option value={"Social Campaigns"}>Social Campaigns</option>
            <option value={"Animation"}>Animation</option>
          </select>
        </div>
        <button className="btn" type="submit">
          Consultation
        </button>
      </form>
    </div>
  );
};

export default ConsultationForm;
